// curated list of skipped releases - primitive but effective
export const skipped: { version: string; reason: string }[] = [
  {
    version: "22.22",
    reason: "Memorial Day Weekend",
  },
  {
    version: "22.27",
    reason: "July 4th Weekend",
  },
  {
    version: "22.36",
    reason: "¯\\_(ツ)_/¯",
  },
  {
    version: "22.48",
    reason: "Thanksgiving",
  },
  {
    version: "22.52",
    reason: "End of 2022",
  },
  {
    version: "23.22",
    reason: "May 2023 Memorial Day Break",
  },
  {
    version: "23.25",
    reason: "June 2023 Juneteenth Break",
  },
  {
    version: "23.27",
    reason: "July 2023 3rd/4th Country Celebration Break",
  },
  {
    version: "23.36",
    reason: "September 2023 Labor Day Break",
  },
  {
    version: "23.48",
    reason: "November 2023 Thanksgiving Break",
  },
  {
    version: "23.51",
    reason: "December 2023 Christmas Break",
  },
  {
    version: "23.52",
    reason: "December 2023 Christmas Break",
  },
  {
    version: "24.1",
    reason: "January 2024 New Year Break",
  },
  {
    version: "24.2",
    reason: "January 2024 New Year Break",
  },
];
